/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'convenience_store': {
    width: 110,
    height: 110,
    viewBox: '0 0 110 110',
    data: '<path pid="0" d="M98.525 42.513L66.57 10.012C66.294 4.443 61.228 0 55.001 0 48.775 0 43.71 4.443 43.434 10.012L11.477 42.513H0l3.73 19.495h6.045l6.75 39.66c.791 4.654 5.424 8.332 10.322 8.332h57.922c4.898 0 9.44-3.678 10.123-8.332l5.81-39.66h6.041L110 42.513H98.525zM46.236 17.321c2.123 2.222 5.26 3.635 8.766 3.635 3.507 0 6.639-1.409 8.766-3.635l24.775 25.192H21.465l24.771-25.192zm-20.642 84.171l-4.048-30.283h11.052l2.836 30.283h-9.84zm16.792 0l-1.989-30.283h11.047l.791 30.283h-9.849zm26.642 0h-9.849l.064-30.283h11.048l-1.263 30.283zm16.796 0h-9.848l2.118-30.283h11.048l-3.317 30.283z" _fill="#2B363B"/>'
  }
})
